export const SET_ADD_RESOURCE_REQUEST = "SET_ADD_RESOURCE_REQUEST";
export const SET_ADD_RESOURCE_SUCCESS = "SET_ADD_RESOURCE_SUCCESS";
export const SET_ADD_RESOURCE_ERROR = "SET_ADD_RESOURCE_ERROR";
export const SET_REMOVE_RESOURCE =  "SET_REMOVE_RESOURCE";
export const SET_INCLUDE_RESOURCE = "SET_INCLUDE_RESOURCE";